export function getPropertyValueOrDefault(types, type) {
    return types[type] || "";
}
//# sourceMappingURL=getPropertyValueOrDefault.js.map